import { Mode } from './types';

export const getBorderBgColor = (activeMode: Mode) => {
  if (activeMode === 'pm') return 'bg-slate-200';
  if (activeMode === 'frontend') return 'bg-rose-200';
  if (activeMode === 'backend') return 'bg-[#21262D]';
  if (activeMode === 'mobile') return 'bg-slate-400/20';
  if (activeMode === 'blockchain') return 'bg-[#003300]';
  if (activeMode === 'qa') return 'bg-cyan-300';
  if (activeMode === 'ai') return 'bg-[#C5C6C7]/20';
  return 'bg-slate-200';
};

export const getAccentBgColor = (activeMode: Mode) => {
  if (activeMode === 'pm') return 'bg-indigo-600';
  if (activeMode === 'frontend') return 'bg-rose-600';
  if (activeMode === 'backend') return 'bg-emerald-500';
  if (activeMode === 'mobile') return 'bg-sky-500';
  if (activeMode === 'blockchain') return 'bg-[#FF6B00]';
  if (activeMode === 'qa') return 'bg-cyan-500';
  if (activeMode === 'ai') return 'bg-[#00F0FF]';
  return 'bg-indigo-600';
};

interface ProjectWithDescriptions {
  descriptions?: Partial<Record<Mode, string>>;
  desc?: string;
}

export const getDesc = (obj: ProjectWithDescriptions, activeMode: Mode) => {
  return obj.descriptions?.[activeMode] || obj.descriptions?.['pm'] || obj.desc;
};

interface ExperienceWithTech {
  tech?: Partial<Record<Mode, string[]>> | string[];
}

export const getTech = (obj: ExperienceWithTech, activeMode: Mode): string[] => {
  // If tech is an object with perspective-based values
  if (obj.tech && typeof obj.tech === 'object' && !Array.isArray(obj.tech)) {
    return obj.tech[activeMode] || obj.tech['pm'] || [];
  }
  // If tech is a simple array (backward compatibility)
  if (Array.isArray(obj.tech)) {
    return obj.tech;
  }
  return [];
};
